import * as React from 'react';
import { Button } from '@mui/material';
import { useFilterList } from '../../../context/FilterListProvider';
import ChartView, { IChartViewChartState } from './chart-view';

/**
 * Toolbar button that opens the order-assignments chart dialog
 * ({@link ChartView}), seeding it with the currently applied filter list.
 */
export const ChartButton = () => {
    const [filterList] = useFilterList();
    const [chart, setChart] = React.useState<IChartViewChartState>({ open: false });

    const handleClick = () => {
        setChart({ open: true, filterList: filterList });
    };

    return (
        <>
            <Button size="small" onClick={handleClick}>Chart View</Button>
            {chart.open && <ChartView chart={chart} setChart={setChart} />}
        </>
    );
};

export default ChartButton;
